import script from "./TenantAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantAccountView.vue?vue&type=script&setup=true&lang=js"

import "./TenantAccountView.vue?vue&type=style&index=0&id=06b3d15c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b3d15c"]])

export default __exports__